(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // 🚨 getBoundingClientRect().height, NIE offsetHeight (2026-09-06, zgloszenie usera:
      // „mikro biala linia miedzy announcement barem a headerem"). `offsetHeight` zwraca
      // ZAOKRAGLONA liczbe calkowita, a naglowek na telefonie ma wysokosc ulamkowa
      // (padding liczony z --wfs plus logo 2,6rem przy 1rem = 11px). Na home hero jest
      // podciagane pod naglowek marginesem `calc(-1 * var(--header-height))`, wiec przy
      // realnych np. 74,4 px i zmiennej 74 px zostawal ulamek piksela bialego tla strony,
      // widoczny jako wlos pod paskiem ogloszen. Rect daje wartosc ulamkowa i luka znika.
      // 🚨 PRZYWROCONE 2026-09-08: commit e4a2d99 (sync z live) skopiowal ten plik z live
      // 1:1 i cofnal poprawke razem z asekuracja -1px w brand CSS.
      document.documentElement.style.setProperty('--header-height', `${this.header.getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        // 🚨 INITIAL CHECK TLA (2026-08-11): po odswiezeniu strony przewinietej
        // w dol przegladarka przywraca scrollY BEZ zdarzenia scroll dla tego
        // handlera (a onScroll przed tym callbackiem i tak nie zna headerBounds),
        // wiec header zostawal bez .scrolled-past-header = przezroczysta
        // nawigacja do pierwszego ruchu. Tu znamy juz headerBounds, wiec
        // ustawiamy SAMA klase tla wg realnej pozycji. Celowo bez hide()/
        // reveal() - chowanie headera na starcie to inna decyzja niz przy
        // realnym scrollu i przy sticky "always" i tak jest no-opem.
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.header.classList.toggle('scrolled-past-header', scrollTop > this.headerBounds.bottom);
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
